import React, { useState } from "react";

interface ControllerMatchTypeProps {
  selectedCriteria: string[];
  onChange: func;
}

const ControllerMatchType: React.FC<ControllerMatchTypeProps> = ({ selectedCriteria, onChange }) => {
  const [criteria, setCriteria] = useState(["LEAGUE", "CUP", "FRIENDLY"]);

  const onClick = (p) => {
    onChange(p);
  };

  return (
    <div className="d-flex flex-row border light-background-color">
      {criteria.map((c) => (
        <button
          className={"btn btn-small " + (selectedCriteria && selectedCriteria.includes(c) ? "selected" : "")}
          onClick={() =>
            onClick(
              selectedCriteria.includes(c) ? selectedCriteria.filter((m) => m !== c) : selectedCriteria.concat([c])
            )
          }
        >
          {c}
        </button>
      ))}
    </div>
  );
};

export default ControllerMatchType;
